export const viTri = {
  sections: {
    list: { title: '库位' },
    detail: { title: '库位' },
  },
  titles: { add: '新增库位', edit: '编辑库位', create: '创建库位' },
  columns: {
    chiNhanh: '门店',
    code: '编码',
    summary: '库位名称',
    note: '备注',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    status: '状态',
    onOffAction: '启停',
  },
  filter: {
    searchPlaceholder: '按编码或名称搜索...',
    textDetailTitle: '高级筛选',
  },
  filters: {
    hintSection: '提示',
    hintBody: '商品使用的库位目录。',
    statusAll: '全部',
    chiNhanhAll: '全部门店',
    chiNhanhSearch: '搜索门店',
    chiNhanhEmpty: '暂无门店',
  },
  status: {
    dangHoatDong: '启用',
    ngungHoatDong: '停用',
  },
  actions: {
    pause: '停用',
    activate: '启用',
  },
  messages: {
    loadError: '无法加载库位列表。',
    deleteSuccess: '已删除库位。',
    noData: '暂无库位。',
    listSummary: '共 {count} 条',
    saveSuccess: '已保存库位。',
    statusChanged: '状态已更新。',
    createSuccess: '已创建库位',
    selectedCount: '已选 {count} 项',
    deleteSelected: '删除所选 ({count})',
    bulkDeleteConfirm: '删除所选 {count} 个库位？',
    bulkDeleteSuccess: '已删除 {count} 个库位',
    bulkDeletePartial: '已删除 {ok}/{total}，{failed} 项删除失败。',
    bulkDeleteError: '批量删除失败',
    bulkDeleteNoneSelected: '未选择要删除的库位',
  },
  form: {
    tenViTri: '库位名称',
    tenViTriInline: '库位',
    maViTri: '编码（可选）',
    ghiChu: '备注',
  },
  validation: {
    tenRequired: '请输入库位名称。',
  },
  import: {
    description:
      'Excel 文件包含 3 列：库位编码（可选）、库位名称（必填）、备注（可选）。编码留空将自动生成；已有编码将更新。',
    success: '已从 Excel 导入库位。',
    failed: '从 Excel 导入库位失败。',
    empty: 'Excel 文件没有有效数据行。',
  },
  placeholders: {
    formTitle: '库位',
    formBody: '',
    tenViTri: '请输入库位名称',
  },
}
